(() => {
  const name = 'gr-rebajas-offer-timer';
  if (customElements.get(name)) return;

  const timers = new Set();
  let scheduledTick = null;
  let listening = false;

  const parseDeadline = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?(Z|[+-]\d{2}:?\d{2})$/.exec(value || '');
    if (!match) return NaN;

    const [, year, month, day, hour, minute, second, , zone] = match;
    const fields = [year, month, day, hour, minute, second].map(Number);
    const [y, m, d, h, min, s] = fields;
    if (m < 1 || m > 12 || d < 1 || h > 23 || min > 59 || s > 59) return NaN;

    const calendar = new Date(0);
    calendar.setUTCFullYear(y, m - 1, d);
    calendar.setUTCHours(h, min, s, 0);
    if (calendar.getUTCFullYear() !== y || calendar.getUTCMonth() !== m - 1 || calendar.getUTCDate() !== d) return NaN;

    if (zone !== 'Z') {
      const digits = zone.slice(1).replace(':', '');
      if (Number(digits.slice(0, 2)) > 23 || Number(digits.slice(2)) > 59) return NaN;
    }

    const normalized = value.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    return Date.parse(normalized);
  };

  const stopScheduler = () => {
    if (scheduledTick !== null) clearTimeout(scheduledTick);
    scheduledTick = null;
    if (listening) document.removeEventListener('visibilitychange', resume);
    listening = false;
  };

  const schedule = () => {
    if (!timers.size) {
      stopScheduler();
      return;
    }
    if (!listening) {
      document.addEventListener('visibilitychange', resume);
      listening = true;
    }
    if (scheduledTick !== null) clearTimeout(scheduledTick);
    let delay = 15000;
    const now = Date.now();
    timers.forEach((timer) => {
      delay = Math.min(delay, Math.max(25, timer.deadline - now));
    });
    scheduledTick = setTimeout(tick, delay);
  };

  const tick = () => {
    scheduledTick = null;
    const now = Date.now();
    timers.forEach((timer) => {
      if (!timer.isConnected || !timer.update(now)) timers.delete(timer);
    });
    schedule();
  };

  const resume = () => {
    if (!document.hidden) {
      if (scheduledTick !== null) clearTimeout(scheduledTick);
      tick();
    }
  };

  class GoldenRoseOfferTimer extends HTMLElement {
    static get observedAttributes() {
      return ['data-deadline'];
    }

    connectedCallback() {
      this.hidden = true;
      queueMicrotask(() => {
        if (this.isConnected) this.initialize();
      });
    }

    disconnectedCallback() {
      timers.delete(this);
      schedule();
    }

    attributeChangedCallback() {
      if (this.isConnected) this.initialize();
    }

    initialize() {
      timers.delete(this);
      this.remaining = this.querySelector('.gr-rebajas-offer-timer__remaining');
      this.discount = this.querySelector('.gr-rebajas-offer-timer__discount');
      this.deadline = parseDeadline(this.dataset.deadline);

      if (this.update(Date.now())) timers.add(this);
      schedule();
    }

    update(now) {
      if (!this.remaining || !this.discount?.textContent.trim() || !Number.isFinite(this.deadline) || this.deadline <= now) {
        this.hidden = true;
        return false;
      }

      const minutesLeft = Math.ceil((this.deadline - now) / 60000);
      const days = Math.floor(minutesLeft / 1440);
      const hours = Math.floor((minutesLeft % 1440) / 60);
      const minutes = minutesLeft % 60;
      const short = [];
      const accessible = [];

      if (days > 0) {
        short.push(`${days}${this.dataset.days || 'd'}`);
        accessible.push(`${days} ${this.dataset.daysLabel || this.dataset.days || 'd'}`);
      }
      if (days > 0 || hours > 0) {
        short.push(`${hours}${this.dataset.hours || 'h'}`);
        accessible.push(`${hours} ${this.dataset.hoursLabel || this.dataset.hours || 'h'}`);
      }
      short.push(`${minutes}${this.dataset.minutes || 'm'}`);
      accessible.push(`${minutes} ${this.dataset.minutesLabel || this.dataset.minutes || 'm'}`);

      const output = short.join(' ');
      if (this.remaining.textContent !== output) {
        this.remaining.textContent = output;
        this.remaining.setAttribute('aria-label', accessible.join(', '));
      }
      this.remaining.dateTime = new Date(this.deadline).toISOString();
      this.hidden = false;
      return true;
    }
  }

  customElements.define(name, GoldenRoseOfferTimer);
})();
